import '../../i18n/autoTranslate';
import React, { useState } from "react";
import { MessageCircle, HelpCircle } from "lucide-react";
import { Button } from "../../../components/ui/shadcn/button";
import { Textarea } from "../../../components/ui/shadcn/textarea";
import { Label } from "../../../components/ui/shadcn/label";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../../components/ui/shadcn/accordion";

export default function SupportSettings({ embedded = false } = {}) {
  const [contactMessage, setContactMessage] = useState("");
  const [faqs] = useState([
    {
      question: "How do I reset my password?",
      answer: "Go to Account Settings and use the Change Password option to update your password.",
    },
    {
      question: "How can I contact support?",
      answer: "Use the form below to send us a message, and we'll get back to you within 24 hours.",
    },
  ]);

  const handleContactSubmit = (e) => {
    e.preventDefault();
    // Add logic to send message (e.g., API call)
    console.log("Support message sent:", contactMessage);
    setContactMessage("");
  };

  return (
    <div className="space-y-6">
      {!embedded && (
        <>
          <h2 className="text-2xl font-semibold tracking-tight text-white">Support</h2>
          <p className="text-gray-200/70 text-sm sm:text-base">Get help or contact our support team.</p>
        </>
      )}
      <div className="space-y-6">
        {/* Contact Support */}
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-white">Contact Support</h3>
          <div className="space-y-2">
            <Label className="text-gray-200/80">Message</Label>
            <Textarea
              value={contactMessage}
              onChange={(e) => setContactMessage(e.target.value)}
              placeholder="Describe your issue or question..."
              rows={6}
              className="text-white"
            />
          </div>
          <Button
            onClick={handleContactSubmit}
            disabled={!contactMessage.trim()}
            className="w-full h-11 bg-gradient-to-br from-[#8B7CFF] to-[#6C63FF] text-white hover:shadow-[0_0_50px_rgba(108,99,255,0.35)]"
          >
            <MessageCircle className="h-4 w-4" />
            Send Message
          </Button>
        </div>

        {/* FAQs */}
        <div className="border-t border-white/10 pt-6">
          <h3 className="text-lg font-semibold text-white">Frequently Asked Questions</h3>
          <Accordion type="single" collapsible className="mt-4 rounded-xl border border-white/10 bg-white/5 px-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`faq-${index}`} className="border-white/10">
                <AccordionTrigger className="text-white hover:no-underline">
                  <span className="flex items-center gap-2">
                    <HelpCircle className="h-4 w-4 text-indigo-300" />
                    <span>{faq.question}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-200/70">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
